import { Backdrop } from '@mui/material';
// import CircularProgress from '@material-ui/core/CircularProgress';
import { CircularProgress } from '@mui/material';
import { mainAppBarDimen } from 'component/MainUIFrame/styles/dimensions';
import { useSelector } from 'react-redux';

const NVBackdrop = () => {
  const progressState = useSelector(state => state?.backdrop?.progress);
  // const [open, setOpen] = useState(progressState);

  return (
    <>
      <Backdrop
        sx={{
          zIndex: theme => theme.zIndex.modal + 1,
          backgroundColor: 'rgba(255, 255, 255, 0.5)',
        }}
        open={progressState}
      >
        <div className="centered-justified" style={{ color: '#3D2470' }}>
          <span
            className="spinner-border spinner-border-m"
            role="status"
            aria-hidden="true"
          ></span>
        </div>
      </Backdrop>
    </>
  );
};

export default NVBackdrop;
